export function generateRandomString(alphabet: string, length: number): string {
  if (alphabet.length === 0) {
    throw new Error('Alphabet is required')
  }

  if (!Number.isInteger(length) || length <= 0) {
    throw new Error('Length must be a positive integer')
  }

  const randomValues = new Uint32Array(length)

  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    globalThis.crypto.getRandomValues(randomValues)
  } else {
    for (let index = 0; index < length; index++) {
      randomValues[index] = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)
    }
  }

  let randomString = ''

  for (const randomValue of randomValues) {
    randomString += alphabet[randomValue % alphabet.length]
  }

  return randomString
}
